import { useAuth } from '@/hooks/use-auth';
import { startAnalytics, trackPageView } from '@/lib/analytics';
import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';
/**
 * Mount-once, render-nothing bridge that wires the analytics SDK into the app:
 *  - binds the unload flush listeners,
 *  - emits a de-identified `nav.page_view` on every route change WHILE AUTHENTICATED
 *    (the collect endpoint requires auth; tracking pre-login views would be dropped anyway).
 * Place inside the auth/provider tree so `useAuth` and wouter's `useLocation` resolve.
 */
export function AnalyticsBridge() {
    const { isAuthenticated } = useAuth();
    const [location] = useLocation();
    const last = useRef(null);
    useEffect(() => {
        startAnalytics();
    }, []);
    useEffect(() => {
        if (!isAuthenticated)
            return;
        if (last.current === location)
            return;
        last.current = location;
        trackPageView(location);
    }, [isAuthenticated, location]);
    return null;
}
